// extracted by mini-css-extract-plugin
module.exports = {"resources":"notifications_resources__RMX7A"};